import type { ReceiptPrintMode } from './printConfig';

export type TicketPrintSuccessCopy = { title: string; detail?: string };

/** Toast post-job cuando el ticket salió bien (reimpresión, etc.). */
export function ticketPrintSuccessToast(transport: ReceiptPrintMode): TicketPrintSuccessCopy {
  if (transport === 'agent') {
    return { title: 'Ticket mandado a la impresora' };
  }
  return {
    title: 'Ticket listo',
    detail: 'Imprimí desde la ventana que se abrió',
  };
}

/** Sufijo en toast de cobro (ej. «Venta registrada · $6.980 · …»). */
export function ticketPrintSuccessDetailSuffix(transport: ReceiptPrintMode): string {
  if (transport === 'agent') return ' · Ticket mandado a la impresora';
  return ' · Imprimí desde la ventana del ticket';
}
